import { NgClass } from "@angular/common";
import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { SkogsvardService } from "../../services/skogsvard.service";

@Component({
    selector: "rask-skogsvard-badge",
    templateUrl: "./skogsvard-badge.component.html",
    styleUrls: ["./skogsvard-badge.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class SkogsvardBadgeComponent {
    readonly skogsvardService = inject(SkogsvardService);

    @Input() index: number;
    @Input() skogsvardTyp: string;

    protected getBackground(): string {
        return this.skogsvardService.getSkogsvardtypBgColor(this.skogsvardTyp);
    }

    protected getSkogsvardTypText(): string {
        return this.skogsvardService.getSkogsvardTypDisplayText(this.skogsvardTyp);
    }
}
